import axios from 'axios'

// Configurar axios para localhost
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'https://localhost:7209/api/',
  timeout: 30000, // Aumentado para reportes que pueden tardar más
  headers: {
    'Content-Type': 'application/json',
  },
})

const API_BASE_URL = '/CargaCatedratico'

const cargaCatedraticoService = {
  // Obtener reporte de carga académica por tipo de plan
  async getReporteCarga(tipoPlanId, programacionAcademicaId = null) {
    try {
      console.log('📊 Obteniendo reporte de carga de catedráticos...')
      let url = `${API_BASE_URL}/Reporte/${tipoPlanId}`
      
      if (programacionAcademicaId) {
        url += `?programacionAcademicaId=${programacionAcademicaId}`
      }
      
      const response = await api.get(url)
      console.log('✅ Reporte de carga obtenido:', response.data)
      return response.data
    } catch (error) {
      console.error('Error loading reporte de carga:', error)
      throw error
    }
  },

  // Obtener programaciones académicas por tipo de plan
  async getProgramacionesByTipoPlan(tipoPlanId) {
    try {
      const response = await api.get(`${API_BASE_URL}/ProgramacionesByTipoPlan/${tipoPlanId}`)
      return response.data
    } catch (error) {
      console.error('Error loading programaciones by tipo de plan:', error)
      throw error
    }
  },

  // Obtener estadísticas de carga
  async getEstadisticasCarga(tipoPlanId, programacionAcademicaId = null) {
    try {
      let url = `${API_BASE_URL}/Estadisticas/${tipoPlanId}`
      
      if (programacionAcademicaId) {
        url += `?programacionAcademicaId=${programacionAcademicaId}`
      }
      
      const response = await api.get(url)
      return response.data
    } catch (error) {
      console.error('Error loading estadisticas de carga:', error)
      throw error
    }
  },
}

export default cargaCatedraticoService

